import React from "react";
import { Box } from "@material-ui/core";
import ContentDisponibilidadUmbralPlus from "../DisponibilidadUmbralPlus/components/ContentDisponibilidadUmbralPlus";

export function PublicFlashboard() {
  return (
    <Box sx={{ padding: { xs: 2, sm: 2, md: 3, lg: 0, xl: 0 } }}>
      <ContentDisponibilidadUmbralPlus />
    </Box>
  );
}
